module.exports = __webpack_public_path__ + "static/35invgde-74529e8f0a7e9ba83c9033323100a424.gif";